export interface ThresholdEditModel {
  entityId: string;
  attributeName: string;
  threshold: ThresholdEditThresholdModel;
}

export interface ThresholdEditThresholdModel {
  lowerLimit: number;
  upperLimit: number;
}

export interface ThresholdEditPayloadModel {
  entityId: string;
  attributeName: string;
  threshold: ThresholdEditThresholdModel;
}
